import { ProductCreatePage } from "./ProductCreatePage";

export function OnlineShowcaseProductCreatePage() {
  return <ProductCreatePage catalogMode="online-showcase" />;
}
